
(function($) {

	function initCompare(){

		$(".c-add__compare-add").ajaxify({
			refresh: [
				".c-line-compare"
			],
			history: false,
			onStart: function(data) {
				$('.c-line-compare').addClass('c-line-compare__visible');
				data.sourceElement.closest('.c-add__compare-add').addClass('c-add__hide');
				data.sourceElement.next('.c-add__compare-delete').removeClass('c-add__hide');
			},
			onFinish: function() {
			}
		});

	}

	initCompare();

	function initCompareDelete(){

		$(".c-add__compare-delete").ajaxify({
			refresh: [
				".c-line-compare"
			],
			history: false,
			onStart: function(data) {
				data.sourceElement.closest('.c-add__compare-delete').addClass('c-add__hide');
			},
			onFinish: function() {

			}
		});

	}

	initCompareDelete();

	$(".c-add__compare-delete").click(function(){

		var d = $(this).attr("data-id");
		$(".c-add__compare-add-"+d).removeClass('c-add__hide');

	});

})(jQuery);

